(async () => {
  const apiUrl =
    "https://cj-charles-jewelers.myshopify.com/api/2026-01/graphql.json";

  const numberOfItemsAttr = document
    .querySelector(".pdm-new-arrivals")
    .getAttribute("data-items");

  const numberOfItems = Number(numberOfItemsAttr) || 12;

  const graphqlQuery = `{
    products(first: ${numberOfItems}, sortKey: CREATED_AT, reverse: true, query: "product_type:\\\"Watches\\\" OR product_type:\\\"Preowned Watches\\\"") {
      edges {
        node {
          featuredImage {
            url
            altText
          }
          images(first: 2) {
            edges {
              node {
                url
                altText
              }
            }
          }
          vendor
          handle
          title
          availableForSale
          compareAtPriceRange {
            minVariantPrice {
              amount
            }
            maxVariantPrice {
              amount
            }
          }
          priceRange {
            minVariantPrice {
              amount
            }
            maxVariantPrice {
              amount
            }
          }
        }
      }
    }
  }`;

  const query = JSON.stringify({ query: graphqlQuery });

  const response = await fetch(apiUrl, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: query,
  });

  console.log("pdm response", response);

  const { data } = await response.json();
  console.log("pdm data before", data);

  if (!data) {
    return;
  }

  const products = data.products.edges.map((edge) => edge.node);

  if (!products) {
    return;
  }

  console.log("pdm products", products);

  const template = document.querySelector("#pdm-new-arrivals-item");
  const fragment = document.createDocumentFragment();

  const formatPrice = (price) => {
    const priceInt = Number(price);
    return priceInt
      .toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      })
      .replace("$", "$ ");
  };
  for (const product of products) {
    const node = template.content.cloneNode(true);

    const link = node.querySelector(".pdm-new-arrivals__item");
    link.href = `${window.Shopify.routes.root}products/${product.handle}`;
    link.setAttribute("title", product.title);

    const img = node.querySelector(".item__image .item__image-main");
    img.src = product.featuredImage.url;
    img.alt = product.featuredImage.altText;

    const img2 = node.querySelector(".item__image .item__image-hover");
    if (product.images.edges.length > 1) {
      img2.src = product.images.edges[1].node.url;
      img2.alt = product.images.edges[1].node.altText;
    } else {
      img2.remove();
    }

    const title = node.querySelector(".item__title");
    title.textContent = product.title;

    const vendor = node.querySelector(".item__vendor");
    vendor.textContent = product.vendor;

    const price = node.querySelector(".item__price");
    if (product.availableForSale) {
      if (
        product.priceRange.minVariantPrice.amount !==
        product.priceRange.maxVariantPrice.amount
      ) {
        price.textContent = `${formatPrice(product.priceRange.minVariantPrice.amount)} - ${formatPrice(product.priceRange.maxVariantPrice.amount)}`;
      } else {
        price.textContent = `${formatPrice(product.priceRange.minVariantPrice.amount)}`;
      }
    } else {
      price.textContent = "Sold Out";
    }

    fragment.appendChild(node);
  }

  console.log("pdm new arrivals");

  const slider = document.querySelector(".pdm-new-arrivals .swiper-wrapper");
  slider.appendChild(fragment);
  const existingSwiper = document.querySelector(".pdm-new-arrivals .swiper").swiper;
  if (existingSwiper) {
    existingSwiper.destroy();
  }

  new Swiper(".pdm-new-arrivals .swiper", {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 12,
    autoplay: false,
    loop: false,
    speed: 400,
    navigation: {
      nextEl: ".pdm-new-arrivals .swiper-button-next",
      prevEl: ".pdm-new-arrivals .swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 72,
      },
    },
  });

  document.querySelector(".pdm-new-arrivals__slider").classList.add("shown");
})();
